import { render, staticRenderFns } from "./comp-nota-agrupado-turma.vue?vue&type=template&id=1d274bbc&scoped=true"
import script from "./comp-nota-agrupado-turma.vue?vue&type=script&lang=js"
export * from "./comp-nota-agrupado-turma.vue?vue&type=script&lang=js"
import style0 from "./comp-nota-agrupado-turma.vue?vue&type=style&index=0&id=1d274bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d274bbc",
  null
  
)

export default component.exports